'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

const SocialProofCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      quote: "The transformation wasn't about the technology—it was about getting our leadership aligned and our people ready. This approach made all the difference.",
      author: 'Sarah Chen',
      role: 'Chief Digital Officer',
      company: 'Fortune 500 Financial Services',
      outcome: '40% increase in AI adoption rate',
    },
    {
      quote: "We had invested millions in AI tools but saw minimal impact. The human-centered methodology helped us unlock the value we knew was possible.",
      author: 'Michael Rodriguez',
      role: 'VP of Operations',
      company: 'Global Manufacturing Leader',
      outcome: '$12M in operational savings',
    },
    {
      quote: "The structured change management framework gave us confidence to scale AI across the organization. Results exceeded our projections.",
      author: 'Jennifer Park',
      role: 'Chief Strategy Officer',
      company: 'Healthcare Technology Provider',
      outcome: '3x faster time-to-value',
    },
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials?.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials?.length) % testimonials?.length);
  };

  return (
    <section className="py-20 lg:py-32 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-headline text-primary mb-6">
              What Enterprise Leaders Say
            </h2>
            <p className="text-xl text-muted-foreground font-body">
              Real results from organizations that transformed their AI journey.
            </p>
          </div>

          <div className="relative">
            <div className="bg-card rounded-2xl p-8 lg:p-12 shadow-strong border border-border">
              <div className="mb-8">
                <Icon name="ChatBubbleLeftRightIcon" size={48} variant="solid" className="text-primary/20" />
              </div>

              <blockquote className="text-xl md:text-2xl text-foreground font-body mb-8 leading-relaxed">
                "{testimonials?.[currentIndex]?.quote}"
              </blockquote>

              <div className="flex items-center justify-between">
                <div>
                  <div className="font-semibold text-lg text-primary mb-1">
                    {testimonials?.[currentIndex]?.author}
                  </div>
                  <div className="text-sm text-muted-foreground mb-1">
                    {testimonials?.[currentIndex]?.role}
                  </div>
                  <div className="text-sm text-muted-foreground">
                    {testimonials?.[currentIndex]?.company}
                  </div>
                </div>

                <div className="hidden md:block">
                  <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-success/10 border border-success/20">
                    <Icon name="CheckCircleIcon" size={20} variant="solid" className="text-success" />
                    <span className="text-sm font-semibold text-success">
                      {testimonials?.[currentIndex]?.outcome}
                    </span>
                  </div>
                </div>
              </div>

              <div className="md:hidden mt-4">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-success/10 border border-success/20">
                  <Icon name="CheckCircleIcon" size={20} variant="solid" className="text-success" />
                  <span className="text-sm font-semibold text-success">
                    {testimonials?.[currentIndex]?.outcome}
                  </span>
                </div>
              </div>
            </div>

            <div className="flex items-center justify-center gap-4 mt-8">
              <button
                onClick={prevTestimonial}
                className="p-3 rounded-full bg-card border border-border hover:border-primary hover:bg-primary/5 transition-all duration-300"
                aria-label="Previous testimonial"
              >
                <Icon name="ChevronLeftIcon" size={24} variant="solid" className="text-primary" />
              </button>

              <div className="flex gap-2">
                {testimonials?.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentIndex(index)}
                    className={`w-2 h-2 rounded-full transition-all duration-300 ${
                      index === currentIndex ? 'bg-primary w-8' : 'bg-border'
                    }`}
                    aria-label={`Go to testimonial ${index + 1}`}
                  />
                ))}
              </div>

              <button
                onClick={nextTestimonial}
                className="p-3 rounded-full bg-card border border-border hover:border-primary hover:bg-primary/5 transition-all duration-300"
                aria-label="Next testimonial"
              >
                <Icon name="ChevronRightIcon" size={24} variant="solid" className="text-primary" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProofCarousel;